<template>
  <BaseLayout
    class="dcb-partner"
    theme-footer="small"
  >
    <slot />
    <template #menu>
      <div class="dcb-partner__menu-wrapper"></div>
    </template>
  </BaseLayout>
</template>

<script setup lang="ts">
import BaseLayout from '~/components/base-layout.vue';

// useHead({
//   meta: [{ name: 'color-scheme', content: 'only light' }],
//   style: [{ innerHTML: ':root { color-scheme: only light; }' }],
// });
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
.dcb-partner {
  &__menu-wrapper {
    display: none;
    @include mq($mq-md) {
      display: flex;
      align-items: center;
    }
  }

  :deep(.mainnav__wrapper) {
    @include mq($mq-md) {
      justify-content: flex-start;
    }
  }

  :deep(.page-header) {
    top: 0 !important;
    position: relative;
  }
  :deep(.mainnav__logo-wrapper) {
    @include mq($mq-md) {
      flex: initial;
      margin-right: 2rem;
    }
  }

  :deep(.mainnav__desktop-menus) {
    @include mq($mq-md) {
      flex: 1 1 auto;
      width: auto;
    }
  }

  :deep(.layout__container) {
    min-height: calc(100vh - var(--nav-height) - 24px);
  }
}
</style>
